import { render, staticRenderFns } from "./BaseToggleSidebarButton.vue?vue&type=template&id=70c70716&scoped=true"
import script from "./BaseToggleSidebarButton.vue?vue&type=script&lang=js"
export * from "./BaseToggleSidebarButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c70716",
  null
  
)

export default component.exports